export const artistData = {
  name: "Alexander Richard",
  businessName: "CountrySoulN'Roll Entertainment",
  tagline: "Faith, Family & Real Country Music",
  bio: "Alexander Richard is a Nebraska-born troubadour with powerful vocals and a nostalgic country sound. Five years on the road and counting; Alexander tours the Midwest performing 12–16 shows a month, mixing original songs and classic covers. In September 2025, he opened for Ashes & Arrows (America's Got Talent) in his hometown of Hastings, Nebraska, marking a milestone hometown performance. Touring under CountrySoulN'Roll Entertainment, Alexander carries on the tradition of faith, family, and real country music—one show at a time.",
  style: "Nostalgia driven, troubadour style country music and oldies rock music from the 60's to the early 2000's.",
  coverArtists: [
    "George Strait", "Elvis", "Garth Brooks", "George Jones", 
    "Willie Nelson", "Waylon Jennings", "Alan Jackson", 
    "Brooks and Dunn", "Johnny Cash", "CCR"
  ],
  images: {
    hero: "https://images.unsplash.com/photo-1725221673945-8574b7091f55?w=1920&q=80",
    performance: "https://images.unsplash.com/photo-1631061434620-db65394197e2?w=1200&q=80",
    about: "https://images.unsplash.com/photo-1590652592840-ea624d193095?w=800&q=80",
    barn: "https://images.unsplash.com/photo-1642365903463-31b4f01b3a5b?w=1920&q=80"
  }
};

export const contactData = {
  receptionist: {
    name: "AI Receptionist: Rachel",
    phone: "531-248-5473"
  },
  human: {
    name: "Real Human",
    phone: "531-222-4606"
  },
  ascap: {
    licenseNumber: "500902112",
    representative: "Chris Bailey",
    phone: "+1 (615) 727-5916"
  }
};

export const socialLinks = {
  facebook: "https://www.facebook.com/share/1B11PPM9yF/?mibextid=wwXIfr",
  youtube: "https://youtube.com/@alexanderrichard2146?si=CRP4TXoJU0noKCmF",
  youtubeVideo: "https://youtu.be/FF6KxPFYjKY?si=1bXNoGxNKB1lehrn"
};

export const coverageAreas = [
  { state: "Nebraska", abbr: "NE", isBase: true },
  { state: "Tennessee", abbr: "TN", isBase: false },
  { state: "Iowa", abbr: "IA", isBase: false },
  { state: "Kansas", abbr: "KS", isBase: false },
  { state: "Minnesota", abbr: "MN", isBase: false },
  { state: "South Dakota", abbr: "SD", isBase: false },
  { state: "Missouri", abbr: "MO", isBase: false },
  { state: "Colorado", abbr: "CO", isBase: false }
];

export const services = [
  {
    id: "solo",
    name: "Solo Acoustic",
    description: "Intimate acoustic performance perfect for smaller venues and personal events",
    icon: "guitar"
  },
  {
    id: "duo",
    name: "Duo",
    description: "Enhanced sound with two performers for a fuller musical experience",
    icon: "users"
  },
  {
    id: "fullband",
    name: "Full Band",
    description: "Complete band experience with 3-5 piece ensemble for larger events",
    icon: "music"
  }
];

export const flatRatePricing = {
  title: "Flat Rate Pricing",
  subtitle: "For Bar/Pub Establishments & Daily Operating Businesses",
  effectiveDate: "January 2026",
  currentPricing: {
    solo: "$150/hour",
    fullBand: "$500/hour",
    note: "Minimum two, maximum four hours"
  },
  packages: [
    {
      name: "Solo Acoustic Show",
      price: "$200",
      unit: "per hour",
      details: "Minimum of two hours. Maximum of four hours.",
      includes: "Price includes lights, sound system, lodging, fuel, and travel expenses."
    },
    {
      name: "Duo Show",
      price: "$400",
      unit: "per hour",
      details: "Minimum of two hours. Maximum of four hours.",
      includes: "Price includes lights, sound system, lodging, fuel, and travel expenses."
    },
    {
      name: "Full Band Show",
      price: "$600",
      unit: "per hour",
      details: "3-5 piece band. Minimum of two hours. Maximum of four hours.",
      includes: "Price includes lights, sound system, lodging, fuel, and travel expenses."
    }
  ]
};

export const capacityPricing = {
  title: "Capacity Based Pricing",
  subtitle: "For Private Events: Weddings, Community Events, Corporate Events",
  minimum: "Minimum of 60 people per event",
  packages: [
    {
      name: "Solo",
      pricePerPerson: "$10",
      example: "200 guests = $2,000"
    },
    {
      name: "Duo",
      pricePerPerson: "$15",
      example: "200 guests = $3,000"
    },
    {
      name: "Full Band",
      pricePerPerson: "$20",
      example: "200 guests = $4,000"
    },
    {
      name: "Large Band",
      pricePerPerson: "$30",
      example: "200 guests = $6,000",
      note: "More than 4 performers"
    }
  ]
};

export const venueTypes = [
  "Weddings",
  "County Fairs",
  "Private Parties",
  "Bars & Pubs",
  "Honkytonks",
  "Fundraisers",
  "Corporate Events",
  "Community Events"
];
